import React from 'react';
import { ProgressIndicator } from '@eb/eds-progress-indicator';

import './progressIndicator.scss';

export const CoyoteProgressIndicator = ({
    style = 'gradient',
    'data-spec': dataSpec,
}) => (
    <div className="eds-spinner-coyote-container">
        <div className="eds-spinner-coyote-position">
            <ProgressIndicator style={style} data-spec={dataSpec} />
        </div>
    </div>
);
